import { kioskApi } from '../axios.js';
export const ezPairingApi = {
    // Get questions for a shop
    getQuestions: (shopId, config) => kioskApi.get(`/ez-pairing/shops/${shopId}/questions`, config),
    // Update questions for a shop
    updateQuestions: (shopId, questions) => kioskApi.put(`/ez-pairing/shops/${shopId}/questions`, { questions }),
    // Generate mappings for a shop
    generateMappings: (shopId, useLLM = true) => kioskApi.post(`/ez-pairing/shops/${shopId}/generate-mappings`, { useLLM }),
    // Get recommendations based on answers
    getRecommendations: (shopId, answers) => kioskApi.post(`/ez-pairing/shops/${shopId}/recommendations`, { answers }),
    // Get mappings summary
    getMappingsSummary: (shopId) => kioskApi.get(`/ez-pairing/shops/${shopId}/mappings-summary`),
    // Demo settings stored on kiosk instance config (per join code)
    getDemoSettings: (joinCode) => kioskApi.get(`/ez-pairing/instances/${encodeURIComponent(joinCode)}/demo-settings`),
    updateDemoSettings: (joinCode, settings) => kioskApi.put(`/ez-pairing/instances/${encodeURIComponent(joinCode)}/demo-settings`, settings)
};
